import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    error: 'The two PIN codes are not identical. Please enter it again.',
    next: 'Submit my PIN code',
    request: 'Request card',
    subtitle:
      'Set your secure code to validate your operations with this card.',
    title: 'Confirm your PIN code',
  },
  fr: {
    error:
      'Les deux codes PIN ne sont pas identiques. Veuillez le saisir une nouvelle fois.',
    next: 'Valider mon code PIN',
    request: 'Envoyer la demande',
    subtitle:
      'Définissez votre code sécurisé pour valider vos opérations avec cette carte.',
    title: 'Confirmez votre code PIN',
  },
});

export default locales;
